import React, { useState, useCallback, useMemo } from 'react'
import clsx from 'clsx'
import { BLOCKS, ENTITY } from 'src/consts'
import { FitText2 } from 'src/utils/string'
import styles from './styles.module.scss'

export const Group = ({
  entry,
  group,
  transform,
  index,
  entity,
  children,
  highlight,
  onClick,
}) => {
  const [highlighted, setHighlighted] = useState(false)
  const width = entry.x1 - entry.x0
  const height = entry.y1 - entry.y0
  const displayName =
    width >= BLOCKS.MIN_GROUP_HEADER_WIDTH &&
    height >= BLOCKS.MIN_GROUP_HEADER_HEIGHT

  const onMouseEnter = useCallback(() => {
    setHighlighted(true)
    highlight({ ...group, ...entry })
  }, [entry, group, highlight])

  const onMouseLeave = useCallback(() => {
    setHighlighted(false)
    highlight()
  }, [highlight])

  const isCoin = group.parent && group.parent.data.name === 'coin'
  const protocol = group.data.name === 'N/A' ? 'Other' : group.data.name

  if (!isCoin && entity === ENTITY.COIN) {
    //protocol += ' tokens'
  }

  const labelFontSize = useMemo(
    () =>
      FitText2({
        width,
        height: group.full ? 20 * transform.k : transform.k,
        maxFontSize: 13 * transform.k,
        text: protocol,
      }),
    [width, transform.k, group.full, protocol]
  )

  const cssTransform = useMemo(
    () => `translate3d(${entry.x0}px, ${entry.y0}px, 0)`,
    [entry.x0, entry.y0]
  )

  return (
    <section
      onMouseMove={onMouseEnter}
      onMouseLeave={onMouseLeave}
      id={group.data.name}
      className={clsx(styles.groupText, { [styles.highlighted]: highlighted })}
      data-t='group'
      data-index={index}
      style={{
        willChange: 'transform',
        transform: cssTransform,
        width,
        height,
      }}
      onClick={() => onClick(group)}
    >
      {displayName && labelFontSize >= 6 && (
        <div
          className={styles.label}
          style={{
            fontSize: labelFontSize,
            paddingLeft: group.full ? undefined : transform.k * 0.45,
            margin: group.full ? undefined : 0,
          }}
        >
          <div className={styles.textContainer}>
            <div className={styles.textProtocol}>
              {protocol}

              {entity === ENTITY.EXCHANGE && protocol === 'Unverified' && (
                <span className={styles.unverifiedSpecialCaseText}>
                  {' '}
                  (not in scale to verified)
                </span>
              )}
            </div>

            {entity === ENTITY.EXCHANGE && protocol === 'Verified' && (
              <span className={styles.additionalInfo}>by COIN360</span>
            )}
          </div>
        </div>
      )}

      {children}
    </section>
  )
}
